import { render, staticRenderFns } from "./CompanyIndex.vue?vue&type=template&id=64511d17&scoped=true&"
import script from "./CompanyIndex.vue?vue&type=script&lang=js&"
export * from "./CompanyIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIndex.vue?vue&type=style&index=0&id=64511d17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64511d17",
  null
  
)

export default component.exports